const LoadingIcon = `  <svg version="1.1" id="loader-1" x="0px" y="0px"
         width="40" height="40" viewBox="0 0 40 40" >
  <path opacity="0.2"  d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
    s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
    c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
        <path  d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
    C22.32,8.481,24.301,9.057,26.013,10.047z">
    <animateTransform attributeType="xml"
                      attributeName="transform"
                      from="0 20 20"
                      to="360 20 20"
                      dur="0.5s"
                      repeatCount="indefinite"/>
    </path>
  </svg>`

const SuccessIcon = ` <svg   viewBox="0 0 1024 1024" version="1.1"  width="100" height="100">
        <path d="M122.28096 536.623104c-9.940992-9.925632-11.548672-25.360384-2.78528-36.407296l20.487168-25.828352c8.397824-10.58816 24.108032-13.246464 35.211264-5.835776l177.3312 118.35904c9.353216 6.243328 25.452544 5.430272 34.185216-1.654784l468.5824-380.16c10.532864-8.54528 27.030528-7.817216 36.261888 1.400832l11.542528 11.52512c10.04544 10.03008 9.314304 25.951232-1.215488 36.465664l-502.92736 502.183936c-15.64672 15.624192-41.337856 14.94016-57.445376-1.142784l-219.22816-218.9056z" p-id="9907"/>
    </svg>`

const ErrorIcon = `
 <svg viewBox="0 0 1024 1024" version="1.1" width="100" height="100">
       <path d="M168.18242 219.516576l48.700165-48.700165 633.096009 633.096009-48.699142 48.700165L168.18242 219.516576zM216.882586 852.612585l-48.699142-48.700165 633.096009-633.096009 48.699142 48.699142L216.882586 852.612585z" p-id="1790"/>
    </svg>`

type Create = {
    type:'loading' | 'success' | 'error',
    text?:string
}

function create(props:Create):HTMLDivElement{
    const f = document.createElement('DIV')
    const p = document.createElement('P')
    f.classList.add('c-b')
    switch (props.type){
        case 'loading':
            f.innerHTML = LoadingIcon
            p.innerText = props.text || '加载中'
            break;
        case 'success':
            f.innerHTML = SuccessIcon
            p.innerText = props.text || '操作成功'
            break;
        case 'error':
            f.innerHTML = ErrorIcon
            p.innerText = props.text || '操作失败'
            break;
        default:
            f.innerHTML = ErrorIcon
            p.innerText = props.text || '操作失败'
            break;
    }
    f.appendChild(p)
    return (f as HTMLDivElement);
}

function createCover(){
   const cover = document.createElement('div')
    cover.className = 'loading-mask without-react'
    cover.style.display = 'none'
    document.body.appendChild(cover)
    return cover
}

type LoadingProps = {
    status:boolean,
    timer:number | null,
    target:HTMLDivElement,
    showLoading:(text:string) => void,
    checkCover:(el:HTMLDivElement) => void,
    hideLoading:() => void,
    showSuccess:(text:string) => void,
    setTimer:() => void,
    showError:(text:string) => void,
    hideAll:() => void
}

const Loading:LoadingProps = {
    status:false,
    timer:null,
    target:createCover(),
    showLoading(text:string){
        this.checkCover(create({
            type:'loading',
            text
        }))
    },
    hideLoading(){
        this.target.style.display = 'none'
    },
    showSuccess(text:string){
        this.checkCover(create({
            type:'success',
            text
        }))
        this.setTimer()
    },
    hideAll(){
        document.querySelectorAll('.loading-mask ').forEach(item => {
            (item as HTMLDivElement).style.display = 'none'
        })
    },
    showError(text:string){
        this.checkCover(create({
            type:'error',
            text
        }))
        this.setTimer()
    },
    setTimer(){
        if(this.timer){
            clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
            this.hideLoading()
        },2000)
    },
    checkCover(el){
        if(!document.querySelector('.without-react')){
            this.target = createCover()
        }
        this.target.style.display = 'flex'
        this.target.innerHTML = ''
        this.target.appendChild(el)
    }
}

export default Loading
